import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isAppUpdatePending } from '../lib/registerSW';

/**
 * La page d'un chemin : `/admin/relations/abc` et `/admin/relations` sont la même page
 * (ouvrir un mail n'est pas changer de page).
 */
export function pageKeyOf(pathname: string): string {
  return pathname.split('/').filter(Boolean).slice(0, 2).join('/');
}

/**
 * Applique une nouvelle version de l'app (cf. registerSW) au prochain changement de
 * page, jamais pendant qu'on lit ou rédige : l'URL a déjà changé, le rechargement
 * atterrit sur la page demandée.
 */
export function useDeferredAppUpdate(): void {
  const { pathname } = useLocation();
  const currentPage = useRef(pageKeyOf(pathname));

  useEffect(() => {
    const page = pageKeyOf(pathname);
    if (page === currentPage.current) return;
    currentPage.current = page;
    if (isAppUpdatePending()) window.location.reload();
  }, [pathname]);
}
